import axios from 'axios';
import { wrapAxiosInstance } from '../cache/modules/axiosFactory';
import { setupAuthInterceptor, retryWithBackoff } from '../common';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.menu_api.ingredients;

// Helper function to configure the Axios instance
const api = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
}));

// Cached API wrapper for this namespace/group
const cachedApi = wrapAxiosInstance(api, {
  namespace: 'menu_api',
  group: 'ingredients',
  defaultTtl: '10m',
  hashLargeSegments: true,
  emitMeta: true,
});

// Function to fetch all items
export const getAllIngredients = async () => {
  return await retryWithBackoff(() =>
    cachedApi.get('/GetAllItems')
  );
};
  
  // Function to fetch all ingredients by local ID
export const getAllIngredientsByLocalId = async (local_id: number) => {
  return await retryWithBackoff(() =>
    cachedApi.get(`/GetAllIngredientsByLocalId/${local_id}`)
  );
};

  export const getIngredientByLocalIdAndStockControl = async (local_id: number) => {
  return await retryWithBackoff(() =>
    cachedApi.get(`/GetIngredientByLocalIdAndStockControl/${local_id}`)
  );
};


// /GetAllIngredientsByItemId/<int:item_id>

export const getAllIngredientsByItemId = async (itemId: any) => {
  return await retryWithBackoff(() =>
    cachedApi.get(`/GetAllIngredientsByItemId/${itemId}`)
  );
}

// /GetIngredientById/<int:ingredient_id>

export const getIngredientById = async (ingredientId: any) => {
  return await retryWithBackoff(() =>
    cachedApi.get(`/GetIngredientById/${ingredientId}`)
  );
}


  // /CreateIngredient

export const createIngredient = async (ingredientData: any) => {
  const res = await retryWithBackoff(() =>
    api.post('/CreateIngredient', ingredientData)
  );
  await cachedApi.clear();
  return res;
}

// /DeleteIngredient

export const deleteIngredient = async (ingredientId: any) => {
  const res = await retryWithBackoff(() =>
    api.delete(`/DeleteIngredient/${ingredientId}`)
  );
  await cachedApi.clear();
  return res;
}
// /AddIngredientToIngredient/<int:composed_ingredient_id>/<int:ingredient_to_add_id>
// payload: {proportion: <passed float>}

export const addIngredientToIngredient = async (composed_ingredient_id: any, ingredient_to_add_id: any, amount: any) => {
  const payload = {"proportion": amount};
  const res = await retryWithBackoff(() =>
    api.post(`/AddIngredientToIngredient/${composed_ingredient_id}/${ingredient_to_add_id}`, payload)
  );
  await cachedApi.clear();
  return res;
}

// /RemoveIngredientFromIngredients/<int:composed_ingredient_id>/<int:ingredient_to_remove_id>

export const removeIngredientFromIngredients = async (composed_ingredient_id: any, ingredient_to_remove_id: any) => {
  const res = await retryWithBackoff(() =>
    api.delete(`/RemoveIngredientFromIngredients/${composed_ingredient_id}/${ingredient_to_remove_id}`)
  );
  await cachedApi.clear();
  return res;
}

// /UpdateIngredient/<int:ingredient_id

export const updateIngredient = async (ingredientId: any, ingredientData: any) => {
  const res = await retryWithBackoff(() =>
    api.put(`/UpdateIngredient/${ingredientId}`, ingredientData)
  );
  await cachedApi.clear();
  return res;
}

/*
composition_parser = reqparse.RequestParser()
composition_parser.add_argument('ingredients_to_add', type=list, required=False, help='ingredients selections to be added')
composition_parser.add_argument('ingredients_to_delete', type=list, required=False, help='ingredients selections to be removed')

@ns.route('/UpdateIngredientComposition/<int:ingredient_id>')
*/

export const updateIngredientComposition = async (ingredientId: any, ingredients_to_add: any, ingredients_to_delete: any) => {
  const payload = {
    "ingredients_to_add": ingredients_to_add,
    "ingredients_to_delete": ingredients_to_delete
  }
  const res = await retryWithBackoff(() =>
    api.put(`/UpdateIngredientComposition/${ingredientId}`, payload)
  );
  await cachedApi.clear();
  return res;
}

  export const DeleteIngredientsSelected = async (ingredients: string[]) => {
  const res = await retryWithBackoff(() =>
    api.delete('/DeleteIngredientsSelected', {
      data: {
        ingredient_to_delete: ingredients
      }
    })
  );
  await cachedApi.clear();
  return res;
};
